import { TIMELINE } from "@/data/content";

export const Timeline = () => {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-12 py-24 lg:py-32" data-testid="timeline-page">
      <div className="overline">A documented timeline</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#F2EBE5] mt-4 max-w-3xl leading-tight">
        How the genocide unfolded.
      </h1>
      <p className="text-[#A19D98] mt-6 max-w-2xl leading-relaxed">
        Drawn from United Nations reports, the UNITAD investigation, public
        testimonies, and the work of survivor-led organizations.
      </p>

      <div className="mt-20 relative">
        <div className="absolute left-2 top-0 bottom-0 w-px bg-white/15" aria-hidden="true" />
        <ol className="space-y-16">
          {TIMELINE.map((ev, i) => (
            <li
              key={i}
              className="relative pl-12"
              data-testid={`timeline-item-${i}`}
            >
              <div className="absolute left-0 top-2 w-5 h-5 border border-[#D4AF37] bg-[#0A0A0C] flex items-center justify-center">
                <div className="w-1.5 h-1.5 bg-[#D4AF37]" />
              </div>
              <div className="overline text-[#D4AF37]">{ev.date}</div>
              <h3 className="font-serif-display text-2xl lg:text-3xl text-[#F2EBE5] mt-3">
                {ev.title}
              </h3>
              <p className="text-[#A19D98] mt-4 max-w-2xl leading-relaxed">{ev.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default Timeline;
